const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_home.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { buildOnboardingHrefWithRedirect, getRedirectPathFromLocation } from "@/lib/redirect-after-login";
export const Route = createFileRoute("/_home")({
  // Mirrors (home)/layout.tsx's `onboardingGuard()`: signed-in users who have
  // not finished onboarding are bounced to /onboarding. Unauthenticated users
  // fall through so the public home page still renders.
  beforeLoad: async ({
    context: {
      viewer
    },
    location
  }) => {
    const user = viewer.user;
    if (user && !user.isAnonymous && !user.onboardingComplete) {
      throw redirect({
        href: buildOnboardingHrefWithRedirect(getRedirectPathFromLocation(location))
      });
    }
    return {
      user
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});